import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { PermissionService } from '../../admin/services/permission.service';

/**
 * Directiva para mostrar/ocultar elementos basándose en roles del usuario
 * 
 * Uso en HTML:
 * <div *hasRole="'Admin'">Admin Only Content</div>
 * <button *hasRole="'Manager'">Manager Action</button>
 */
@Directive({
  selector: '[hasRole]',
  standalone: true
})
export class HasRoleDirective implements OnInit {
  
  private role: string;
  private hasView = false;
  
  @Input() set hasRole(val: string) {
    this.role = val;
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) { }

  ngOnInit() {
    this.updateView();
  }

  private updateView() {
    const shouldShow = this.checkRole();
    
    if (shouldShow && !this.hasView) {
      // Crear la vista solo si no existe
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      // Eliminar la vista solo si existe
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private checkRole(): boolean {
    if (!this.role) {
      return false;
    }
    return this.permissionService.hasRole(this.role);
  }
}
